export default __webpack_public_path__ + "static/media/gi.401cda35.jpg";